export const substituteIt = (baseString, key, value) => {
    return baseString.replace("${" + key + "}", value);
};


// WEBPACK FOOTER //
// ./src/utils/substitute.js